import React, { useState, useRef, useEffect } from 'react';
import { TextField, Box } from '@mui/material';
import bgimage from '../../assets/svg/bgimg.svg';
import otpimg from '../../assets/svg/OtpPng.svg';
import { Typography, Stack, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { sendLoginOtpServ, verifyLoginOtpServ } from '../../services/login-service';
import { customAlert, notify } from '../../components/notify';
import route from '../../utils/Routes';
import constants from '../../utils/Constants';

function OtpVeryfication() {
  const location = useLocation();
  const email = location.state?.email;
  const otpLength = 6;
  const [otp, setOtp] = useState(Array(otpLength).fill(""));
  const [otpStrg, setOtpStrg] = useState("")
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const { ctxtlogin, setLoadingScreen, ctxtUser } = useAuthContext();

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) { // Only allow numeric input
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setOtpStrg(newOtp.join(""));
      console.log(`OTP--------${newOtp.join("").length}`)
      if (value && index < otpLength - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };
  const handleClick = (index) => {
    inputRefs.current[index].setSelectionRange(0, 1);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus(); // Move to previous input on backspace
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (otpLength !== otpStrg.length) {
      notify("error", "Please enter the complete OTP!");
      return
    }
    setLoadingScreen(true);
    try {
      const { data, message } = await verifyLoginOtpServ({ email, otp: otpStrg });
      console.log(data)
      ctxtlogin(data);
      notify("success", message);
      // if (res?.token && res?.type === 'sa')
      //   navigate(route.saBoLists, { replace: true });
      // else if (res?.token && res?.type === 'staff')
      //   navigate(route.boDashboard, { replace: true });
      // else if (ctxtUser?.token && ctxtUser?.type === 'agent') {
      //   navigate(route.agDashboard, { replace: true });
      // }
      const comUsers = [constants.approver, constants.requestor, constants.focalPoint, constants.lineManager];
      if (data?.token && comUsers.includes(data?.userType))
        navigate(route.comPoTrackingList, { replace: true });
      else if (data?.userType === constants.accounts)
        navigate(route.accComList, { replace: true });
      else if (data?.token && !comUsers.includes(data?.userType))
        navigate(route.comList, { replace: true });

      setLoadingScreen(false);
    } catch (err) {
      console.log(err);
      customAlert(err);

    }
    setLoadingScreen(false);
  };

  async function handleResend() {
    if (!email) {
      navigate(route.login, { replace: true });
      return
    }
    setLoadingScreen(true);
    try {
      const { message } = await sendLoginOtpServ({ email });
      setOtp(Array(otpLength).fill(""));
      setOtpStrg("")
      notify("success", message);
      setLoadingScreen(false);
    } catch (err) {
      console.log(err);
      customAlert(err);

    }
    setLoadingScreen(false);
  };



  useEffect(() => {
    console.log("call use effect ---------------------33");
    setLoadingScreen(true);
    if (ctxtUser?.token) {
      if (ctxtUser?.isComUser === true)
        navigate(route.comPoTrackingList, { replace: true });
      else if (ctxtUser?.userType === constants.accounts)
        navigate(route.accComList, { replace: true });
      else if (ctxtUser?.isComUser === false)
        navigate(route.comList, { replace: true });
    }
    else if (!email)
      navigate(route.login, { replace: true });
    else
      inputRefs.current[0].focus();  //focus the otp first textfield

    setLoadingScreen(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className='bg'>
      <div className='bg'>
        <img src={bgimage} alt="bgimage" style={{ width: "100vw", position: "absolute" }} />
        <img src={otpimg} alt="logo" style={{ width: "50%", height: "24rem", top: "14rem", position: "absolute" }} />
        <Typography sx={{ fontSize: 30, fontWeight: 700, left: "68vw", marginTop: "19vh", position: "absolute" }}>Verification</Typography>
        <form style={{ position: "relative", left: "62vw", marginTop: "26vh", }} id='formId' onSubmit={handleSubmit}>
          <Stack className='otpgrid' sx={{ alignItems: "center", width: "22rem", height: "24rem" }}>
            <Typography sx={{ fontSize: 14, mt: 3, ml: 3.5, fontWeight: 400, color: "secondary.sub" }}>One Time Password (OTP) sent to {email}.  Please enter it below to complete verification.</Typography>
            <Stack sx={{ alignItems: "left" }}>
              <Typography sx={{ color: "secondary.main", mt: 5, mb: 1, fontSize: 14, fontWeight: 400 }}>Email OTP</Typography>
              <Box display="flex" justifyContent="center" gap={1}>
                {otp.map((digit, index) => (
                  <TextField
                    key={index}
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onClick={() => handleClick(index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    inputProps={{
                      maxLength: 1,
                      style: { textAlign: 'center', width: 12, height: 25, backgroundColor: "white" },
                    }}
                    inputRef={(el) => (inputRefs.current[index] = el)} // Store reference to each input field
                    variant="outlined"
                    size="small"
                  />
                ))}
              </Box>
            </Stack>
            <Button sx={{ mt: 4, padding: "1px", borderRadius: 2, backgroundColor: "primary.button", width: 200, fontSize: 16, height: 35 }}
              variant="contained" type='Su'>Verify</Button>
            <Button style={{ fontSize: 13 }} sx={{ mt: 1, color: "rgba(23, 98, 228, 1)", border: "none" }}
              variant="outlined" onClick={handleResend}
            >Resend OTP</Button>
          </Stack>
        </form>
        <Stack sx={{ width: "100%", alignItems: "center", marginTop: "90vh", position: "absolute" }}>
          <Typography sx={{ fontSize: 15, fontWeight: 400 }}>© 2024, AMTL.com, Inc. or its affiliates</Typography>
        </Stack>
      </div>
    </div>
  );
};
export default OtpVeryfication;

// wr